import * as React from 'react'
import { SVGProps } from 'react'
const SvgGiftWrap = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25} height={23} viewBox="0 0 25 23" fill="none" {...props}>
    <path
      d="M2.628 9.468h7.778V21.5H3.782a1.154 1.154 0 0 1-1.154-1.154V9.468ZM21.976 9.468v10.814c0 .672-.546 1.218-1.218 1.218h-6.561V9.468h7.779ZM10.407 6.09v3.377H1.74A.74.74 0 0 1 1 8.727V6.83c0-.41.331-.741.74-.741h8.667ZM23.603 6.83v1.897a.74.74 0 0 1-.74.74h-8.666V6.09h8.665c.41 0 .741.331.741.74ZM14.197 6.09h-3.79V21.5h3.79V6.09Z"
      stroke="#146C92"
      strokeWidth={1.101}
      strokeMiterlimit={10}
    />
    <path
      d="M12.302 6.09h-5.3c-.942-.49-1.53-1.377-1.506-2.284.033-1.218 1.156-2.096 2.016-2.27 1.57-.316 3.672 1.43 4.79 4.554Z"
      stroke="#146C92"
      strokeWidth={1.101}
      strokeMiterlimit={10}
    />
    <path
      d="M19.107 3.806c.024.907-.565 1.795-1.507 2.284h-5.298c1.117-3.124 3.22-4.87 4.789-4.553.86.173 1.984 1.051 2.016 2.269Z"
      stroke="#146C92"
      strokeWidth={1.101}
      strokeMiterlimit={10}
    />
  </svg>
)
export default SvgGiftWrap
